import {
  createContext,
  useCallback,
  useState,
  useContext,
} from "react";
import { useQuery } from "@tanstack/react-query";
import { getRequest } from "services/api";
import { LIMIT_DATA_PER_PAGE } from "utils/constants";
import { buildQueryString } from "utils/queryHelpers";

const TripContext = createContext();

export const TripProvider = ({ children }) => {
  const [filterOptions, setFilterOptions] = useState({
    search: "",
    currentPage: 1,
    totalPages: 1,
    filter: {
      id: "",
      name: "",
      date: new Date().toISOString().split("T")[0],
    },
  });

  const updateFilterTrip = (key, value) => {
    setFilterOptions((prevState) => ({
      ...prevState,
      filter: {
        ...prevState.filter,
        [key]: value,
      },
    }));
  };

  const handleSearch = (e) => {
    if (e.key === "Enter") {
      setFilterOptions((prevState) => ({
        ...prevState,
        search: e.target.value,
      }));
    }
  };

  // ✅ Fetch function pakai Tanstack Query
  const fetchTripsAvailable = async () => {
    const reservationDateFilter = filterOptions.filter.date;

    const queryStringWithFilter = buildQueryString({
      [`filter[date]`]: reservationDateFilter,
      // Optional: bisa tambahkan include, page, limit kalau dibutuhkan
    });

    const response = await getRequest(`/trip-availability${queryStringWithFilter}`);
    if (response.success) {
      return response;
    } else {
      throw new Error("Failed to fetch trips");
    }
  };

  // ✅ Pakai useQuery untuk fetching + caching
  const {
    data: tripsData,
    isLoading,
    error,
    refetch,
  } = useQuery({
    queryKey: ["trips-available", filterOptions.filter.date],
    queryFn: fetchTripsAvailable,
    keepPreviousData: true,
    // staleTime: 10000,
    // refetchInterval: 10000, // optional: auto-refresh tiap 10 detik
    // staleTime 5 menit
    staleTime: 5 * 60 * 1000,
    refetchInterval: 5 * 60 * 1000,
  });

  // ✅ Format state trips agar konsisten dengan versi sebelumnya
  const trips = {
    data: tripsData?.data || [],
    pagination: tripsData?.pagination || null,
    error,
    loading: isLoading,
  };

  return (
    <TripContext.Provider
      value={{
        trips,
        filterOptions,
        setFilterOptions,
        handleSearch,
        updateFilterTrip,
        refetchTrip: refetch, // 🚀 bisa dipakai buat refresh manual
      }}
    >
      {children}
    </TripContext.Provider>
  );
};

export const useTrip = () => {
  const context = useContext(TripContext);
  if (!context) {
    throw new Error("useTrip must be used within a TripProvider");
  }
  return context;
};
